import React, { useState, useContext, createContext, useEffect } from "react";

// ** Hooks Imports
import { useAuth } from "./useAuth";

// ** Services Imports
import { NotificationServices } from "../services/NotificationServices";

const notificationContext = createContext();

export function ProviderNotification({ children }) {
  const notification = useProviderNotification();
  return (
    <notificationContext.Provider value={notification}>
      {children}
    </notificationContext.Provider>
  );
}

export const useNotification = () => {
  return useContext(notificationContext);
};

// Provider hook that creates object and handles state
function useProviderNotification() {
  // ** Hooks
  const { userSecure } = useAuth();
  /**
   *  State
   */
  const [notifications, setNotifications] = useState([]);
  const [newNotifications, setNewNotifications] = useState([]);

  // ** Get All Notifications & calculate Notifications count not readed
  function getUserNotifications(access_token) {
    if (access_token) {
      NotificationServices.getAll({ token: access_token })
        .then((result) => {
          const { data } = result;
          if (Array.isArray(data?.notifications)) {
            const newItem = [];
            // eslint-disable-next-line array-callback-return
            data?.notifications?.map((item) => {
              if (item.read === "0" || item.read === 0) newItem.push(item);
            });
            setNewNotifications([...newItem]);
            setNotifications([...data?.notifications]);

            console.log("newItem data", newItem);
          }
        })
        .catch((error) => {});
    }
  }

  // ** Get notification by ID
  const getNotificationByID = (id) => {
    return new Promise((resolve, reject) => {
      if (Object.keys(userSecure).length > 0) {
        const { access_token } = userSecure;
        NotificationServices.getByID({ token: access_token, id: id })
          .then((result) => {
            resolve({ data: result?.data });
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 404) {
                reject({ messageEror: "There are no notification" });
              }
            } else {
              reject({ messageEror: "Oops Error!" });
            }
          });
      } else {
        reject({ messageEror: "not found notification" });
      }
    });
  };

  // ** Set Read notification
  const setReadNotification = (id) => {
    const getNotRead = notifications.find((el) => el.id === id);
    if (getNotRead && Object.keys(getNotRead).length > 0) {
      if (getNotRead?.read === "0") {
        const { access_token } = userSecure;
        NotificationServices.setReadeByID({ token: access_token, id: id })
          .then((result) => {
            getUserNotifications(access_token);
          })
          .catch((error) => {
            console.log("error", error);
          });
      }
    }
  };

  // ** Delete Notification
  const deleteNotification = (id) => {
    return new Promise((resolve, reject) => {
      if (Object.keys(userSecure).length > 0) {
        const { access_token } = userSecure;
        NotificationServices.deleteByID({ token: access_token, id: id })
          .then((result) => {
            resolve({ data: result?.data });
            getUserNotifications(access_token);
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 404) {
                reject({ messageEror: "There are no notification" });
              }
            } else {
              reject({ messageEror: "Oops Error!" });
            }
          });
      } else {
        reject({ messageEror: "Oops Error!" });
      }
    });
  };

  useEffect(() => {
    if (Object.keys(userSecure).length > 0) {
      const { access_token } = userSecure;
      getUserNotifications(access_token);
    }
    return () => {};
  }, [userSecure]);

  return {
    notifications,
    newNotifications,
    getNotificationByID,
    setReadNotification,
    deleteNotification
  };
}
